import React from 'react';
import Create  from  './Create';

const Edit = (props) => {
  return <Create {...props} action={true}/>
};

export default Edit;
